var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moz-title"},[_c('span',{staticClass:"title"},[_vm._t("title")],2),_c('span',{staticClass:"subtitle"},[_vm._t("subtitle")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }